'use client';

import styles from './upcomingEvents.module.css';
import { EventCard } from '@/components/eventCard/eventCard';
import { EventItem } from '@/app/interfaces/event';
import { useLocale, useTranslations } from 'next-intl';
import { AnimatedList } from '@/components/componentAnimation/animatedListComponent';

type UpcomingEventsProps = {
  events: EventItem[];
};

export default function UpcomingEvents({ events }: UpcomingEventsProps) {
  const locale = useLocale();
  const t = useTranslations('EventPage');

  return (
    <section className={styles.upcomingSection}>
      <div className={styles.upcomingHeader}>
        <h2 className={styles.upcomingTitle}>{t('upcomingEvents')}</h2>
        <p className={styles.upcomingSubtitle}>{t('upcomingEventsCheck')}</p>
      </div>
      {events.length === 0 && <div className={styles.noEvents}>
        <p>{t('noUpcomingEvents')}</p>
      </div>}

      {events.length > 0 && <AnimatedList isHorizontal={true} className={styles.eventsGrid}>
        {events.map((event) => (
          <div key={event.id} className={styles.cardWrapper}>
            <EventCard
              key={event.id}
              event={event}
              explore={t('explore')}
              locale={locale}
            />
          </div>
        ))}
      </AnimatedList>}
    </section>
  );
}
